import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import logo from '../../assets/images/login-logo.png';
import * as _ from 'lodash';
import moment from 'moment';

const BookingDetailsPdf = ({ data, unitConfig }) => {
    return (
        <Document>
            <Page style={styles.body}>
                {data?.transit_agency?.logo && (
                    <Image
                        style={styles.image}
                        src={data?.transit_agency?.logo}
                        onError={(e) => {
                            e.target.src = logo;
                            return e;
                        }}
                    />
                )}
                <View style={styles.mainContainer}>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Commuter:</Text>
                            <Text style={styles.subtitle}>{_.capitalize(data?.commuter?.name)}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Agency:</Text>
                            <Text style={styles.subtitle}>{data?.transit_agency?.name}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Starting Station:</Text>
                            <Text style={styles.subtitle}>{data?.starting_station?.name}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Ending Station:</Text>
                            <Text style={styles.subtitle}>{data?.last_station?.name}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Transit Type:</Text>
                            <Text style={styles.subtitle}>{_.capitalize(data?.transit_type)}</Text>
                        </View>
                    </View>

                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Total Amount:</Text>
                            <Text style={styles.subtitle}>$ {data?.payment?.totalAmount / 100 || 1}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Date:</Text>
                            <Text style={styles.subtitle}>{moment(data?.date).format('YYYY-MM-DD')}</Text>
                        </View>
                    </View>
                    <View style={styles.dataBox}>
                        <View style={styles.textualData}>
                            <Text style={styles.title}>Distance:</Text>
                            <Text style={styles.subtitle}>
                                {' '}
                                {data?.distance || 0}
                                {data?.distance ? unitConfig.distanceUnit : null}
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    dataBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        border: '1px solid #d3d3d3',
        borderRadius: '10px',
        padding: '5px',
        paddingLeft: 2,
        width: '250px',
        height: 'auto',
        margin: '5px'
    },
    textualData: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5,
        padding: '5px',
        marginLeft: '2px'
    },
    title: {
        fontSize: 14,
        textAlign: 'start'
    },
    subtitle: {
        fontSize: 12,
        color: '#505050',
        fontWeight: 'bold',
        maxWidth: 150,
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal'
    },
    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify'
    },
    image: {
        marginVertical: 50,
        marginHorizontal: 100
    },
    header: {
        fontSize: 18,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
        fontWeight: 'semibold'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    }
});

export default BookingDetailsPdf;
